import axios from 'axios'
export default class Service {
  constructor() {
    this.urlBase = process.env.VUE_APP_URL_API

    this.urlRecursoAPI = 'rest/app/app'
    this.urlRecursoWeb = 'web'
  }

  getRequisicaoPadrao(payload, method, programa = '') {
    var send = {
      uid: '',
      pwd: '',
      ptoP: programa == '' ? 'admin/weadmrh026.p' : programa,
      params: [
        {
          parametro: 'pcMetodo',
          data_type: 'char',
          param_type: 'input',
          valor: method,
        },
        {
          parametro: 'pcParametros',
          data_type: 'longchar',
          param_type: 'input',
          valor: payload,
        },
        {
          parametro: 'pcRetorno',
          data_type: 'longchar',
          param_type: 'output',
          valor: '',
        },
      ],
    }

    return axios.put(this.urlBase + '/' + this.urlRecursoAPI, send)
  }

  validaCPF(payload) {
    return this.getRequisicaoPadrao(JSON.stringify(payload), 'validaCPF')
  }

  validaSenha(payload) {
    return this.getRequisicaoPadrao(JSON.stringify(payload), 'validaSenha')
  }

  getCidadeCEP(cep) {
    return axios.get('https://viacep.com.br/ws/' + cep + '/json/')
  }

  getGrauEstrucao() {
    return this.getRequisicaoPadrao('', 'geragrauinstrucao')
  }

  getAreaInteresse() {
    return this.getRequisicaoPadrao('', 'geraareainteresse')
  }

  getEducacao() {
    return this.getRequisicaoPadrao('', 'educacao')
  }

  getPaises() {
    return this.getRequisicaoPadrao('', 'gerapais')
  }

  getUF() {
    return this.getRequisicaoPadrao('', 'gerauf')
  }

  getPais() {
    return this.getRequisicaoPadrao('', 'gerapais')
  }

  getCidadesTrabalho() {
    return this.getRequisicaoPadrao('', 'geracidadeTrab')
  }

  getCargosTrabalho() {
    return this.getRequisicaoPadrao('', 'geracargo')
  }

  getEstadoCivil() {
    return this.getRequisicaoPadrao('', 'geraestadocivil')
  }

  getIdiomas() {
    return this.getRequisicaoPadrao('', 'idioma')
  }

  getVagas() {
    return this.getRequisicaoPadrao('', 'geravagas')
  }

  buscaPessoa() {
    return this.getRequisicaoPadrao(
      '{"codpessoa":' + parseInt(localStorage.getItem('codPessoa')) + '}',
      'buscaPessoa'
    )
  }

  buscaFormacao() {
    return this.getRequisicaoPadrao(
      '{"codpessoa":' + parseInt(localStorage.getItem('codPessoa')) + '}',
      'buscaFormacao'
    )
  }

  buscaHistorico() {
    return this.getRequisicaoPadrao(
      '{"codpessoa":' + parseInt(localStorage.getItem('codPessoa')) + '}',
      'buscahistoricoprof'
    )
  }

  buscaIndicacoes() {
    return this.getRequisicaoPadrao(
      '{"codpessoa":' + parseInt(localStorage.getItem('codPessoa')) + '}',
      'buscaindicacao'
    )
  }

  buscaIdioma() {
    return this.getRequisicaoPadrao(
      '{"codpessoa":' + parseInt(localStorage.getItem('codPessoa')) + '}',
      'buscaidioma'
    )
  }

  buscaAreas() {
    return this.getRequisicaoPadrao(
      '{"codpessoa":' + parseInt(localStorage.getItem('codPessoa')) + '}',
      'buscaAreaInteresse'
    )
  }

  gravaDadosPessoais(pessoa) {
    return this.getRequisicaoPadrao(
      '{"ttPessoa": [ ' + JSON.stringify(pessoa) + ' ]}',
      'gravaDadosPessoais'
    )
  }

  gravaAreasInteresse(areas) {
    return this.getRequisicaoPadrao(
      '{"ttAreaInteresseCandidato":  ' + JSON.stringify(areas) + ' }',
      'gravaAreaInteresse'
    )
  }

  gravaFormacaoAcademica(formacoes) {
    return this.getRequisicaoPadrao(
      '{"ttFormacao":  ' + JSON.stringify(formacoes) + ' }',
      'gravaFormacaoAcademica'
    )
  }

  gravaHistoricoProfissional(historicos) {
    return this.getRequisicaoPadrao(
      '{"ttHistoricoProfissional":  ' + JSON.stringify(historicos) + ' }',
      'gravaHistoricoProfissional'
    )
  }

  gravaPessoaReferencia(indicacoes) {
    return this.getRequisicaoPadrao(
      '{"ttIndicacao":  ' + JSON.stringify(indicacoes) + ' }',
      'gravaPessoaReferencia'
    )
  }

  gravaIdioma(idiomas) {
    return this.getRequisicaoPadrao(
      '{"ttIdiomaPessoa":  ' + JSON.stringify(idiomas) + ' }',
      'gravaidioma'
    )
  }

  setVaga(vaga) {
    return this.getRequisicaoPadrao(
      '{"codRequisicao": ' +
        vaga +
        ', "codPessoa":' +
        parseInt(localStorage.getItem('codPessoa')) +
        '}',
      'candidatarparavaga'
    )
  }

  alteraSenha(senha) {
    return this.getRequisicaoPadrao(
      '{"senha": "' +
        senha.toString() +
        '", "codpessoa":' +
        parseInt(localStorage.getItem('codPessoa')) +
        '}',
      'alterasenha'
    )
  }

  esqueceuSenha(cod) {
    return this.getRequisicaoPadrao(
      '{"codpessoa":' + cod + '}',
      'esqueceusenha'
    )
  }

  enviaSMS(cod, telefone) {
    return this.getRequisicaoPadrao(
      '{"codpessoa":' + cod + ', "telefone": "' + telefone + '"}',
      'enviasms'
    )
  }

  enviaEmail(cod, email) {
    return this.getRequisicaoPadrao(
      '{"codpessoa":' + cod + ', "email": "' + email + '"}',
      'enviaemail'
    )
  }

  buscaObsLGPD(cod) {
    return this.getRequisicaoPadrao('{"codPessoa":' + cod + '}', 'buscaLgpd')
  }

  getPDFLgpd() {
    return axios.get(
      this.urlBase +
        //`/web/DownloadUploadFiles?tabela=pessoaObs&campo=Anexo&chave=ObsLGPD&usuario=mestre&senha=Mariana23`
        `/web/DownloadUploadFiles?tabela=pessoaObs&campo=Anexo&chave=ObsLGPD`
    )
  }

  getUrlTermo() {
    return (
      this.urlBase +
      //`/web/DownloadUploadFiles?tabela=pessoaObs&campo=Anexo&chave=ObsLGPD&usuario=mestre&senha=Mariana23`
      `/web/DownloadUploadFiles?tabela=pessoaObs&campo=Anexo&chave=ObsLGPD`
    )
  }

  gravaObs(cod) {
    return this.getRequisicaoPadrao('{"codPessoa":' + cod + '}', 'gravaObs')
  }

  uploadArquivo(arquivo, tabela, campo, data) {
    var formData = new FormData()
    formData.append('files', arquivo)

    const url = encodeURI(
      this.urlBase +
        `/web/DownloadUploadFiles?tabela=${tabela}&campo=${campo}&chave=${localStorage.getItem(
          'codPessoa'
        )}|${data}`
    )

    return axios.post(url, formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    })
  }  

  getParamCurriculo() {
    return this.getRequisicaoPadrao('', 'buscaParamCurriculo')
  }

  buscaVeiculacao() {
    return this.getRequisicaoPadrao('', 'buscaVeiculacao')
  }  
}
